import axios from "axios";
import url from "../config/urlServiceConfig";

const programsAPI = {
  getAll: () => axios.get("ProgramCard"),
  create: (body) => axios.post(url.program, body),
  update: (body) => axios.put(url.program, body),
  delete: (id) => axios.delete(`${url.program}/${id}`),
};

export default programsAPI;
